import TemporaryShippingInfo from '@/src/modules/checkout/content/TemporaryShippingInfo'
import { SimpleFieldWrapper } from '@/src/modules/build-a-card/StepElement'
import { StyledList } from '@/src/modules/build-a-card/StyledComponents'

const ShippingInfoText = () => {
    return (
        <SimpleFieldWrapper>
            <p>Shipping information will be collected during checkout.</p>
            <StyledList>
                <li>Order by 4PM ET Mon-Sat for same-day shipping.</li>
                <TemporaryShippingInfo type={'itemized-shipping-message'} />
                <li>
                    Orders placed after 4PM ET, on Sundays, or US Holidays are
                    printed and shipped the following day.
                </li>
                <li>For use in USA only.</li>
            </StyledList>
        </SimpleFieldWrapper>
    )
}

export default ShippingInfoText
